<template>
    <el-dialog
        class="detail-dialog-container"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">短信提醒</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="page-title-two flex align-center">短信充值请联系客服<i>400-999-6541</i></div>
            <div class="flex">
                <div class="members flex flex-direction">
                    <div v-for="(item,index) in members" :key="index">{{item.user_type === 1 ? item.company : item.name}} - {{item.phone}}</div>
                </div>
                <div class="flex flex-direction flex-sub margin-left-sm">
                    <div class="content">
                        {{ message }}
                    </div>
                    <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm">
                        <el-form-item prop="content">
                            <el-input v-model="ruleForm.content" placeholder="请输入内容" type="textarea" resize="none"
                                      :autosize="{ minRows: 3, maxRows: 3 }" @input="inputChange">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <div class="page-tip self-end">目前{{ inputCount }}个字符，预计耗费<span>{{ Math.ceil(inputCount / 140)* members.length }}</span>条短信,目前剩余<span>{{ smsNumber
                }}</span>数
            </div>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">取消</el-button>
                <el-button class="operate" :loading="loading" @click="submitForm('ruleForm')">
                    发送提醒
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {getMobanByType, getSMSShengYuNumber, sendMessage} from '@/api/organiz'
import {getStringByteLen} from "@/utils/utils";

export default {
    name: "HeartSmsDialog",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        members: { //详情ID
            type: [Array, String],
            default: ''
        },
        type: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            message:'',
            template_id:'',
            demo_message:'',
            ruleForm: {
                content: '',
            },
            rules: {
                content: [
                    {required: true, message: '请输入内容', trigger: 'blur'},
                    {min: 5, message: '建议至少为 5 个字符', trigger: 'blur'}
                ]
            },
            inputCount: 0,
            smsNumber: 0,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        if (this.type) this.init()
    },
    methods: {
        async init() {
            let _data = await getSMSShengYuNumber()
            this.smsNumber = _data.data

            _data = await getMobanByType(this.type)
            let datum = _data.data
            this.template_id = datum.template_id
            this.demo_message = datum.demo
            this.ruleForm.content =datum.content
            this.message = this.demo_message.replaceAll('{1}', this.user.morgname)
            this.message = this.message.replaceAll('{2}', this.ruleForm.content)
            this.inputCount = getStringByteLen(this.message)
        },
        submitForm(formName) {
            let count = Math.ceil(this.inputCount / 140) * this.members.length
            if (this.smsNumber < count) return this.$message.error('剩余条数不足')
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendMessage(count);
                }
            });
        },
        async sendMessage(count) {
            this.loading = true
            let _data = await sendMessage(
                this.user.morgname + ',' + this.ruleForm.content,
                this.template_id,
                JSON.stringify(this.members),count
            )
            this.loading = false
            if (_data.status === 200) {
                this.$message.success(_data.msg)
                this.$emit('watchState', true)
            }
        },
        cancel() {
            this.$emit('watchState', false)
        },

        inputChange() {
            this.message = this.demo_message.replaceAll('{1}', this.user.morgname)
            this.message = this.message.replaceAll('{2}', this.ruleForm.content)
            this.inputCount = getStringByteLen(this.message)
        }
    },
    watch: {
        dialogVisible() {
            if (this.type && this.dialogVisible) this.init()
        },
    }
}
</script>

<style scoped lang="scss">
.page-title-two {
    font-size: 14px;
    line-height: 45px;
    color: #666666;

    i {
        display: inline-block;
        width: 140px;
        height: 20px;
        text-align: center;
        line-height: 18px;
        font-size: 14px;
        background-image: linear-gradient(37deg,
            #ffb400 0%,
            #fc7802 100%),
        linear-gradient(
                #0a2240,
                #0a2240);
        background-blend-mode: normal,
        normal;
        border-radius: 9px;
        color: #fff;
    }
}

.page-tip {
    span {
        color: #ffb400;
    }
}

.detail-dialog-container {
    .dialog-container {
        .dialog-header {
            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .dialog-close {
                font-size: 21px;
                color: #0a2240;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .members{
            border: 1px solid #eeeeee;
            font-size: 14px;
            line-height: 1.5;
            color: #0a2240;
            margin-bottom: 16px;
            padding: 10px;
            border-radius: 6px;
            width: 200px;
        }

        .content {
            border: 1px solid #eeeeee;
            font-size: 14px;
            line-height: 1.5;
            color: #0a2240;
            margin-bottom: 16px;
            padding: 10px;
            border-radius: 6px;
        }

        .dialog-operate {
            margin-top: 20px;

            .operate {
                width: 200px;
                height: 40px;
                border-radius: 20px;
                font-size: 16px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                color: #ffffff;

                &.black {
                    background: #0a2240 none;
                }
            }

            .operate + .operate {
                margin-left: 80px;
            }
        }

        .dialog-footer {
            height: 40px;
            background-color: #e7eff9;
            padding: 0 20px;
            border-radius: 0 0 10px 10px;

            .content {
                font-size: 16px;
                color: #8b9fbe;
            }
        }
    }
}
</style>